/**
 * Barra de marca no topo do app.
 *
 * A logo abaixo é um PLACEHOLDER em SVG inline (usa currentColor, então
 * funciona em light e dark). Para trocar pela definitiva, substitua o bloco
 * <svg> por <img src="/mobile-logo.svg" alt="..." className="h-7" />.
 */
export const MobileBrandBar = () => {
  return (
    <header className="flex shrink-0 items-center justify-center border-b border-border bg-card px-4 pb-2.5 pt-[max(env(safe-area-inset-top),10px)]">
      <div className="flex items-center gap-2 text-foreground">
        <span className="flex h-8 w-8 items-center justify-center rounded-[10px] bg-accent-blue">
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
          </svg>
        </span>
        <span className="text-[17px] font-bold tracking-tight">
          Sua<span className="text-accent-blue">Marca</span>
        </span>
      </div>
    </header>
  );
};
